import { Box, Typography } from "@mui/material";
import { FormatRelativeDateAbbreviated } from "~/lib/date";

type LastUpdatedCellProps = {
  value: string | null | undefined;
};

export function LastUpdatedCell({ value }: LastUpdatedCellProps) {
  const formattedDate = value ? FormatRelativeDateAbbreviated(value) : "-";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          fontSize: "14px",
        }}
      >
        {formattedDate}
      </Typography>
    </Box>
  );
}
